import { createApp } from 'vue'
import NewCarLoanCalculatorInputs from './NewCarLoanCalculatorInputs'
import handleComponentProps from '../../../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--new-car-loan-calculator-inputs'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((NewCarLoanCalculatorInputsDOM) => {
            const props = handleComponentProps(NewCarLoanCalculatorInputs, NewCarLoanCalculatorInputsDOM)
            const component = createApp(NewCarLoanCalculatorInputs, props).use(Store)
            component.mount(NewCarLoanCalculatorInputsDOM)
        })
    }
}
